export default __webpack_public_path__ + "static/media/18Liter.41b61a76.png";